import template from './delegatedCardRequestCounter.html';
import controller from './delegatedCardRequestCounter.controller';
import './delegatedCardRequestCounter.scss';

let delegatedCardRequestCounterComponent = {
  restrict: 'E',
  bindings: {
    cards: '<',
  },
  template,
  controller,
};

export default delegatedCardRequestCounterComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardRow/homeDelegatedCard/delegatedCardRequestCounter/delegatedCardRequestCounter.component.js